import { useState, useRef, useEffect } from 'react';
import ProductSearchModal from './ProductSearchModal';
import type { BasketItem } from '../page';

interface ScanBasketAreaProps {
  selectedLineIndex: number | null;
  onSelectLine: (index: number | null) => void;
  basketItems: BasketItem[];
  setBasketItems: (items: BasketItem[]) => void;
}

interface Product {
  id: string;
  code: string;
  name: string;
  category: string;
  price: number;
  stock: number;
  barcode: string;
  unit: string;
  image: string;
}

const allProducts: Product[] = [
  { id: 'P001', code: 'MLK-001', name: 'Organic Whole Milk 1L', category: 'dairy', price: 4.99, stock: 156, barcode: '8901234567890', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=organic%20whole%20milk%20bottle%20in%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=mlk001&orientation=squarish' },
  { id: 'P002', code: 'BRD-001', name: 'Fresh Bread Whole Wheat', category: 'bakery', price: 3.49, stock: 89, barcode: '8901234567891', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=fresh%20whole%20wheat%20bread%20loaf%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=brd001&orientation=squarish' },
  { id: 'P003', code: 'COF-001', name: 'Premium Coffee Beans 500g', category: 'beverages', price: 12.99, stock: 45, barcode: '8901234567892', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=premium%20coffee%20beans%20bag%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=cof001&orientation=squarish' },
  { id: 'P004', code: 'YOG-001', name: 'Greek Yogurt 500g', category: 'dairy', price: 5.49, stock: 234, barcode: '8901234567893', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=greek%20yogurt%20container%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=yog001&orientation=squarish' },
  { id: 'P005', code: 'BAN-001', name: 'Organic Bananas', category: 'produce', price: 2.99, stock: 450, barcode: '8901234567894', unit: 'kg', image: 'https://readdy.ai/api/search-image?query=fresh%20organic%20bananas%20bunch%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=ban001&orientation=squarish' },
  { id: 'P006', code: 'EGG-001', name: 'Free Range Eggs (12 pack)', category: 'dairy', price: 6.99, stock: 178, barcode: '8901234567895', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=free%20range%20eggs%20carton%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=egg001&orientation=squarish' },
  { id: 'P007', code: 'CHE-001', name: 'Cheddar Cheese 200g', category: 'dairy', price: 4.79, stock: 123, barcode: '8901234567896', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=cheddar%20cheese%20block%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=che001&orientation=squarish' },
  { id: 'P008', code: 'JUI-001', name: 'Orange Juice 1L', category: 'beverages', price: 4.99, stock: 267, barcode: '8901234567897', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=orange%20juice%20bottle%20carton%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=jui001&orientation=squarish' },
  { id: 'P009', code: 'PAS-001', name: 'Pasta Penne 500g', category: 'pantry', price: 2.49, stock: 345, barcode: '8901234567898', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=penne%20pasta%20package%20bag%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=pas001&orientation=squarish' },
  { id: 'P010', code: 'SAU-001', name: 'Tomato Sauce 400g', category: 'pantry', price: 1.99, stock: 456, barcode: '8901234567899', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=tomato%20sauce%20can%20jar%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=sau001&orientation=squarish' },
  { id: 'P011', code: 'SPI-001', name: 'Fresh Spinach 250g', category: 'produce', price: 3.29, stock: 89, barcode: '8901234567900', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=fresh%20spinach%20leaves%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=spi001&orientation=squarish' },
  { id: 'P012', code: 'CHK-001', name: 'Chicken Breast', category: 'meat', price: 12.99, stock: 67, barcode: '8901234567901', unit: 'kg', image: 'https://readdy.ai/api/search-image?query=fresh%20chicken%20breast%20meat%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=chk001&orientation=squarish' },
  { id: 'P013', code: 'APP-001', name: 'Red Apples', category: 'produce', price: 3.99, stock: 234, barcode: '8901234567902', unit: 'kg', image: 'https://readdy.ai/api/search-image?query=fresh%20red%20apples%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=app001&orientation=squarish' },
  { id: 'P014', code: 'RIC-001', name: 'Basmati Rice 5kg', category: 'pantry', price: 15.99, stock: 78, barcode: '8901234567903', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=basmati%20rice%20bag%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=ric001&orientation=squarish' },
  { id: 'P015', code: 'BUT-001', name: 'Salted Butter 250g', category: 'dairy', price: 4.29, stock: 145, barcode: '8901234567904', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=salted%20butter%20package%20block%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=but001&orientation=squarish' },
  { id: 'P016', code: 'TOM-001', name: 'Cherry Tomatoes 500g', category: 'produce', price: 4.49, stock: 167, barcode: '8901234567905', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=cherry%20tomatoes%20package%20container%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=tom001&orientation=squarish' },
  { id: 'P017', code: 'SAL-001', name: 'Atlantic Salmon Fillet', category: 'meat', price: 18.99, stock: 34, barcode: '8901234567906', unit: 'kg', image: 'https://readdy.ai/api/search-image?query=atlantic%20salmon%20fillet%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=sal001&orientation=squarish' },
  { id: 'P018', code: 'TEA-001', name: 'Green Tea Bags 100ct', category: 'beverages', price: 8.99, stock: 89, barcode: '8901234567907', unit: 'ea', image: 'https://readdy.ai/api/search-image?query=green%20tea%20bags%20box%20package%20on%20clean%20white%20background%20product%20photography%20minimalist%20style%20simple%20backdrop%20professional%20lighting%20high%20quality%20commercial%20photo&width=200&height=200&seq=tea001&orientation=squarish' },
];

export default function ScanBasketArea({ selectedLineIndex, onSelectLine, basketItems, setBasketItems }: ScanBasketAreaProps) {
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const filteredProducts = searchQuery.length >= 2 
    ? allProducts.filter(product => {
        const query = searchQuery.toLowerCase();
        return product.name.toLowerCase().includes(query) ||
               product.code.toLowerCase().includes(query) ||
               product.barcode.includes(query);
      }).slice(0, 8) // Limit to 8 results
    : [];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) &&
          inputRef.current && !inputRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
    setShowDropdown(value.length >= 2);
    setSelectedIndex(-1);
  };

  const handleAddProduct = (product: Product, quantity: number = 1) => {
    const newItem: BasketItem = {
      line: basketItems.length + 1,
      code: product.code,
      name: product.name,
      qty: quantity,
      price: product.price,
      discount: false,
      tax: true,
      total: product.price * quantity,
    };
    setBasketItems([...basketItems, newItem]);
    setSearchQuery('');
    setShowDropdown(false);
    inputRef.current?.focus();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!showDropdown || filteredProducts.length === 0) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev < filteredProducts.length - 1 ? prev + 1 : prev
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => prev > 0 ? prev - 1 : -1);
        break;
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0 && selectedIndex < filteredProducts.length) {
          handleAddProduct(filteredProducts[selectedIndex]);
        }
        break;
      case 'Escape':
        setShowDropdown(false);
        setSelectedIndex(-1);
        break;
    }
  };

  const handleRemoveLine = (index: number) => {
    const newItems = basketItems.filter((_, i) => i !== index);
    const renumbered = newItems.map((item, i) => ({ ...item, line: i + 1 }));
    setBasketItems(renumbered);
    if (selectedLineIndex === index) {
      onSelectLine(null);
    }
  };

  const handleUpdateQuantity = (index: number, newQty: number) => {
    if (newQty <= 0) return;
    const newItems = [...basketItems];
    newItems[index].qty = newQty;
    newItems[index].total = newItems[index].price * newQty;
    setBasketItems(newItems);
  };

  return (
    <div className="flex-1 flex flex-col bg-white border-l border-r border-gray-200 overflow-hidden">
      <div className="p-4 border-b border-gray-200">
        <div className="flex gap-2 mb-3">
          <div className="flex-1 relative">
            <i className="ri-barcode-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
            <input
              ref={inputRef}
              type="text"
              value={searchQuery}
              onChange={(e) => handleSearchChange(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Scan barcode, type SKU, or search item..."
              className="w-full pl-10 pr-4 py-2.5 border-2 border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-500"
            />
            
            {showDropdown && filteredProducts.length > 0 && (
              <div 
                ref={dropdownRef}
                className="absolute top-full left-0 right-0 mt-1 bg-white border-2 border-teal-500 rounded-lg shadow-2xl z-50 max-h-96 overflow-y-auto"
              >
                <div className="p-2">
                  <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-b border-gray-200 mb-1">
                    {filteredProducts.length} product{filteredProducts.length !== 1 ? 's' : ''} found
                  </div>
                  {filteredProducts.map((product, index) => (
                    <button
                      key={product.id}
                      onClick={() => handleAddProduct(product)}
                      className={`w-full p-3 rounded-lg text-left transition-colors cursor-pointer flex items-center gap-3 ${
                        selectedIndex === index
                          ? 'bg-teal-50 border-2 border-teal-500'
                          : 'hover:bg-gray-50 border-2 border-transparent'
                      }`}
                    >
                      <div className="w-12 h-12 flex-shrink-0 bg-gray-100 rounded overflow-hidden">
                        <img 
                          src={product.image} 
                          alt={product.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-0.5">
                          <span className="px-1.5 py-0.5 bg-gray-200 text-gray-700 rounded text-xs font-mono whitespace-nowrap">
                            {product.code}
                          </span>
                          <span className="text-xs text-gray-500 capitalize whitespace-nowrap">
                            {product.category}
                          </span>
                        </div>
                        <h4 className="text-sm font-semibold text-gray-900 mb-0.5 truncate">
                          {product.name}
                        </h4>
                        <div className="flex items-center gap-3 text-xs text-gray-600">
                          <span className="whitespace-nowrap">
                            <i className="ri-stack-line mr-1"></i>
                            Stock: {product.stock}
                          </span>
                        </div>
                      </div>
                      <div className="text-right flex-shrink-0">
                        <p className="text-lg font-bold text-gray-900 whitespace-nowrap">
                          ${product.price.toFixed(2)}
                        </p>
                        <p className="text-xs text-gray-500 whitespace-nowrap">per {product.unit}</p>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {showDropdown && searchQuery.length >= 2 && filteredProducts.length === 0 && (
              <div 
                ref={dropdownRef}
                className="absolute top-full left-0 right-0 mt-1 bg-white border-2 border-gray-300 rounded-lg shadow-lg z-50"
              >
                <div className="p-4 text-center">
                  <i className="ri-search-line text-3xl text-gray-300 mb-2"></i>
                  <p className="text-sm text-gray-600">No products found</p>
                  <p className="text-xs text-gray-500 mt-1">Try a different search term</p>
                </div>
              </div>
            )}
          </div>
          <button 
            onClick={() => setShowSearchModal(true)}
            className="px-4 py-2.5 bg-teal-600 hover:bg-teal-700 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-search-line mr-1.5"></i>
            Search
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <table className="w-full">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr className="border-b border-gray-200">
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 whitespace-nowrap">Line</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 whitespace-nowrap">Code</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 whitespace-nowrap">Image</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700 whitespace-nowrap">Description</th>
              <th className="px-3 py-2 text-right text-xs font-semibold text-gray-700 whitespace-nowrap">Qty</th>
              <th className="px-3 py-2 text-right text-xs font-semibold text-gray-700 whitespace-nowrap">Price</th>
              <th className="px-3 py-2 text-center text-xs font-semibold text-gray-700 whitespace-nowrap">Disc</th>
              <th className="px-3 py-2 text-center text-xs font-semibold text-gray-700 whitespace-nowrap">Tax</th>
              <th className="px-3 py-2 text-right text-xs font-semibold text-gray-700 whitespace-nowrap">Total</th>
              <th className="px-3 py-2 text-center text-xs font-semibold text-gray-700 whitespace-nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {basketItems.map((item, index) => {
              const product = allProducts.find(p => p.code === item.code);
              return (
                <tr 
                  key={item.line}
                  onClick={() => onSelectLine(index)}
                  className={`border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors ${
                    selectedLineIndex === index ? 'bg-teal-50' : ''
                  }`}
                >
                  <td className="px-3 py-2.5 text-sm text-gray-900 whitespace-nowrap">{item.line}</td>
                  <td className="px-3 py-2.5 text-sm font-mono text-gray-700 whitespace-nowrap">{item.code}</td>
                  <td className="px-3 py-2.5">
                    <div className="w-12 h-12 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                      {product && (
                        <img 
                          src={product.image} 
                          alt={item.name}
                          className="w-full h-full object-cover object-top"
                        />
                      )}
                    </div>
                  </td>
                  <td className="px-3 py-2.5 text-sm text-gray-900">{item.name}</td>
                  <td className="px-3 py-2.5 text-sm text-gray-900 text-right whitespace-nowrap">
                    <div className="flex items-center justify-end gap-1">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleUpdateQuantity(index, Math.max(0.1, item.qty - (item.qty >= 1 ? 1 : 0.1)));
                        }}
                        className="w-6 h-6 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-700 rounded transition-colors cursor-pointer flex-shrink-0"
                      >
                        <i className="ri-subtract-line text-sm"></i>
                      </button>
                      <input
                        type="number"
                        value={item.qty}
                        onChange={(e) => handleUpdateQuantity(index, parseFloat(e.target.value))}
                        onClick={(e) => e.stopPropagation()}
                        className="w-16 px-2 py-1 text-center border border-gray-300 rounded focus:outline-none focus:border-teal-500"
                        step="0.1"
                        min="0.1"
                      />
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleUpdateQuantity(index, item.qty + (item.qty >= 1 ? 1 : 0.1));
                        }}
                        className="w-6 h-6 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-700 rounded transition-colors cursor-pointer flex-shrink-0"
                      >
                        <i className="ri-add-line text-sm"></i>
                      </button>
                    </div>
                  </td>
                  <td className="px-3 py-2.5 text-sm text-gray-900 text-right whitespace-nowrap">${item.price.toFixed(2)}</td>
                  <td className="px-3 py-2.5 text-center">
                    {item.discount && (
                      <i className="ri-price-tag-3-fill text-amber-500 text-base"></i>
                    )}
                  </td>
                  <td className="px-3 py-2.5 text-center">
                    {item.tax && (
                      <i className="ri-checkbox-circle-fill text-teal-500 text-base"></i>
                    )}
                  </td>
                  <td className="px-3 py-2.5 text-sm font-semibold text-gray-900 text-right whitespace-nowrap">
                    ${item.total.toFixed(2)}
                  </td>
                  <td className="px-3 py-2.5 text-center">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveLine(index);
                      }}
                      className="w-7 h-7 flex items-center justify-center hover:bg-red-100 text-red-600 rounded transition-colors cursor-pointer"
                    >
                      <i className="ri-delete-bin-line text-base"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showSearchModal && (
        <ProductSearchModal 
          onClose={() => setShowSearchModal(false)}
          onAddProduct={handleAddProduct}
        />
      )}
    </div>
  );
}
